import ConfigProvider from "antd/lib/config-provider";
import React from "react";
import { ThemeConfigKeys } from "../utils/Constants";
import { useTheme } from "../utils/UseTheme";

interface ThemeProviderProps {
  children: React.ReactNode;
  themeKey: ThemeConfigKeys;
}

export const ThemeProvider: React.FC<ThemeProviderProps> = ({
  children,
  themeKey,
}) => {
  const theme = useTheme(themeKey);

  return <ConfigProvider theme={theme}>{children}</ConfigProvider>;
};
